import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import { DELETE_ERROR, FETCH_ERROR, SUCCESS_DELETE } from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useFilters } from 'hooks/useFilters';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { BVUService } from 'services/BVUService';
import { BVUForm } from './BVUForm';
import { BVUTable } from './BVUTable';

function BVU() {
  useDocumentTitle('Банки второго уровня');
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger('Банки второго уровня');
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();
  const { page, perPage, totalRows, setPagination, setTotalRows } =
    usePagination();
  const { filters, handleFilters } = useFilters({
    bank_name: '',
  });

  const recordFields = useMemo(() => {
    return [
      { label: 'Swift БИК', key: 'bik' },
      { label: 'Наименование', key: 'name' },
      { label: 'Код банка', key: 'code' },
      { label: 'Город', key: 'city' },
      {
        label: 'Избранный',
        key: 'favorite',
        computedValue: activeRecord?.favorite ? 'Да' : 'Нет',
      },
    ];
  }, [activeRecord]);

  const fetchBanks = useCallback(async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items = [], total } = await BVUService.getBanks({
        page,
        perPage,
        filters,
      });
      setBanks(items);
      setTotalRows(total);
      setCount(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  }, [page, perPage, filters]);

  useEffect(() => fetchBanks(), [fetchBanks]);

  const handleDelete = async () => {
    try {
      const isDeleted = await BVUService.deleteBank(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        fetchBanks();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="bvu" />

      <BVUTable
        items={banks}
        loading={loading}
        onRowClick={openDrawer}
        current={page}
        pageSize={perPage}
        total={totalRows}
        onChange={setPagination}
        onFilter={handleFilters}
      />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={recordFields}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить этот банк ?"
        pageId="bvu"
      />

      <BVUForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchBanks}
        onClose={closeForm}
      />
    </>
  );
}

export { BVU };
